import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from "./pages/Home";
import LoginDeriv from "./pages/LoginDeriv";
import PendingApproval from "./pages/PendingApproval";
import MatchesTool from "./pages/MatchesTool";
import OverUnderTool from "./pages/OverUnder";
import RiseFallTool from "./pages/RiseFall";
import UserDashboard from "./pages/UserDashboard";
import AdminDashboard from "./pages/AdminDashboard";
import AdminLogin from "./pages/AdminLogin";
import CompleteProfile from "./pages/CompleteProfile";
import SiteSuspended from "./components/SiteSuspended";

// Flip to false to bring the site back online.
const SITE_SUSPENDED = true;

function App() {
  if (SITE_SUSPENDED) {
    return <SiteSuspended />;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/login" element={<LoginDeriv />} />
        <Route path="/pending" element={<PendingApproval />} />
        <Route path="/complete-profile" element={<CompleteProfile />} />
        <Route path="/matches" element={<MatchesTool />} />
        <Route path="/overunder" element={<OverUnderTool />} />
        <Route path="/risefall" element={<RiseFallTool />} />
        <Route path="/user" element={<UserDashboard />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route path="/admin/login" element={<AdminLogin />} />
      </Routes>
    </BrowserRouter>
  );
}

export default App;
